<template>
    <frm-patient-search
        data-url="/patient/patient_management/search"
        create-url="/patient/create"
        right
        class="patient-search"
        @patient-search-all="showSearchPatients($event)"
        @patient-selected="showPatient($event)"
    />
</template>

<script>
import ModalManager from '../../services/modalManager';

export default {
    methods: {
        async showPatient(patientId) {
            const result = await ModalManager.openModal(`/calendar/search-appointments?patient=${patientId}`, undefined, undefined, 'full');

            if (result?.action === 'show_appointment' && result.data?.length) {
                return this.$store.dispatch('calendar/showEventInWeekview', String(result.data[0].calendar_item_id));
            }
        },

        async showSearchPatients(query) {
            const result = await ModalManager.openModal(`/calendar/search-patients?query=${query}`, undefined, undefined, 'full');

            if (result?.action === 'select-patient' && result.data?.length) {
                return this.showPatient(result.data[0].id);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.patient-search {
    width: 100%;
}
</style>
